import Yup from 'utils/yup'

export const defaultValues = {
  name: null,
}

export const validationSchema = Yup.object().shape({
  name: Yup.string().nullable().max(40, 'O nome deve ter no máximo 40 caracteres'),
})
